import { initialStateFactory, reducerFactory, sagasFactory } from 'utils/factories';
import actionsFactory from 'utils/factories/actions';
import { BUCKET } from './actionTypes';

// actions
const actions = actionsFactory(BUCKET);
export { actions };

// reducer
const initialState = initialStateFactory();
const reducer = reducerFactory(BUCKET);
export default (state = initialState, action) => reducer(state, action);

// sagas
const sagas = sagasFactory(BUCKET, '/buckets');
export { sagas };
